export const GIT_COMMIT = '804233758e2961f923b59a481831de661ee1d262'
